import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { ServiceCenter } from './components/ServiceCenter';
import { CategoryGrid } from './components/CategoryGrid';
import { VehicleLineup } from './components/VehicleLineup';
import { FinanceTradeIn } from './components/FinanceTradeIn';
import { LeadForm } from './components/LeadForm';
import { MobileActionBar } from './components/MobileActionBar';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="31aqeoda66opo">
      <div className="w-full min-h-full bg-canvas font-sans text-white" data-id="element-1" data-mp="31ayr642drs0c">
        <Header data-id="element-2" data-mp="2wk0av4he6tx3" />
        {/* Compensación por el header fijo (barra superior + navegación) */}
        <main id="main" className="pt-14 lg:pt-28" data-id="element-3" data-mp="28ufo0ai4bcij">
          <Hero data-id="element-4" data-mp="28t4j27cxrypu" />
          <CategoryGrid data-id="element-5" data-mp="28sl5t3y8dyi5" />
          <VehicleLineup data-id="element-6" data-mp="23vchelmhoy8g" />
          <ServiceCenter data-id="element-7" data-mp="23w4gi6fape3h" />
          <FinanceTradeIn data-id="element-8" data-mp="23utcc5hxu4bu" />
          <LeadForm data-id="element-9" data-mp="23t8eo70bu59r" />
        </main>
        <Footer data-id="element-10" data-mp="3ikh98cxzsz0k" />
        {/* Acciones fijas en móvil: llamar, WhatsApp y cotizar */}
        <MobileActionBar data-id="element-11" data-mp="3mlavz2zp87rv" />
        <div className="h-16 lg:hidden" aria-hidden="true" data-id="element-12" data-mp="3mkhlbqxmcy4g" />
      </div>
    </LanguageProvider>;
}